import React from 'react';
import { connect } from 'react-redux';
import {
  addKeywordAutocompleteCustomToken,
  addKeywordAutocompleteToken,
  generateKeywordAutocompleteTokens,
  removeKeywordAutocompleteToken,
  showKeywordAutocompleteLatest,
  updateKeywordAutocompleteValue
} from 'src/redux/actions/searchParams';
import { fetchKeywordAutocomplete, cancelFetchKeywordAutocomplete } from 'src/api/searchParamsRequests';
import { showAutocompleteKeyword } from 'src/redux/actions/view';
import AutocompleteContainer from 'src/containers/AutocompleteContainer';
import { autocompleteDefaultProperties, autocompletePropertyTypes } from 'src/types/autocomplete';


const KeywordContainer = properties => (
  <AutocompleteContainer
    { ...properties }
    name="kw"
    placeholder="stanowisko, firma, słowo kluczowe"
  />
);


fetchKeywordAutocomplete.propTypes = autocompletePropertyTypes;

fetchKeywordAutocomplete.defaultProps = autocompleteDefaultProperties;

const mapStateToProperties = state => (
  {
    autocompleteParams: state.searchParamsReducer.autocomplete.keyword,
    showAutocomplete: state.viewReducer.autocomplete.keyword.show
  }
);

const minKeysToAutocomplete = 2;

const mapDispatchToProperties = dispatch => (
  {
    actions: {
      autocomplete: {
        fetchList: (query) => {
          cancelFetchKeywordAutocomplete();
          if (query.length < minKeysToAutocomplete) {
            dispatch(showKeywordAutocompleteLatest());
          } else {
            fetchKeywordAutocomplete(query, dispatch);
          }
        },
        addTag: tag => dispatch(addKeywordAutocompleteToken(tag - 1)),
        addCustomTag: value => dispatch(addKeywordAutocompleteCustomToken(value)),
        removeTag: tag => dispatch(removeKeywordAutocompleteToken(tag)),
        show: () => dispatch(showAutocompleteKeyword(true)),
        hide: () => dispatch(showAutocompleteKeyword(false)),
        updateValue: value => dispatch(updateKeywordAutocompleteValue(value)),
        generate: () => dispatch(generateKeywordAutocompleteTokens())
      }
    }
  }
);

export default connect(mapStateToProperties, mapDispatchToProperties)(KeywordContainer);
